import { auth } from "@/firebase";
import { FinancialDeckRecord } from "@/models/financialDecks";
import { Route } from "@/paths";
import { CustomCellRendererProps } from "@ag-grid-community/react";
import { Anchor } from "@mantine/core";
import { PiGlobeSimpleBold, PiUsersThreeBold } from "react-icons/pi";

export const NamerRenderer = (props: CustomCellRendererProps) => {
  const deck = props.data as FinancialDeckRecord & { id: string };
  const isPublic =
    deck.allowedEmails &&
    deck.allowedEmails?.length > 0 &&
    deck.allowedEmails?.includes("public") &&
    deck.creatorId === auth.currentUser?.uid;

  const isShared =
    deck.allowedEmails &&
    deck.allowedEmails?.filter((email) => email !== "public").length > 0 &&
    deck.creatorId === auth.currentUser?.uid;

  return (
    <>
      <Anchor
        underline="always"
        href={Route.Model.replace(":modelId", deck.id)}
        inherit
        target="_blank"
      >
        {deck.name}
      </Anchor>{" "}
      {isPublic && <PiGlobeSimpleBold size={16} />}{" "}
      {isShared && <PiUsersThreeBold size={16} />}
    </>
  );
};
